import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-judge-criteria',
  templateUrl: './judge-criteria.component.html',
  styleUrls: ['./judge-criteria.component.css']
})
export class JudgeCriteriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  async download() {
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/COMPETITION%20BRIEFING%20PARTICIPANT.pdf?alt=media&token=c7c713df-8cc2-4c7a-8d06-883492b28284'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "INNOZILLA Competition Briefing Slide.pdf";
    anchor.href = fileURL;
    anchor.click();
  }

  async download2() {
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Sample%20Slide.pdf?alt=media&token=81f46864-c97c-4377-8c89-e546de6f5f0c'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "Pitch Deck Sample.pdf";
    anchor.href = fileURL;
    anchor.click();
  }

}
